var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeadLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 51,
    viewBox: "0 0 47 51",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9843 9.1499H21.5293V18.776H21.9843C25.0675 18.776 27.5933 18.7004 27.5933 13.9769C27.5933 9.25327 24.9407 9.15144 21.9843 9.15144V9.1499Z",
    fill: "#1F295C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3461 13.9745C30.3461 18.4928 27.011 19.1055 21.9824 19.1055H21.5273V23.292C21.5273 25.2472 21.8984 25.9956 22.5795 26.2811H38.0334L30.5248 13.1381L30.224 12.6104C30.3034 13.0208 30.3461 13.4714 30.3461 13.9714V13.9745Z",
    fill: "#1F295C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0269 23.3728V11.5522C19.0269 9.97513 18.7414 9.29928 17.7762 9.17578L15.5086 13.1448L8 26.2847H18.2099C18.8024 25.9575 19.0269 25.1258 19.0269 23.3712V23.3728Z",
    fill: "#1F295C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9844 8.81911H28.0576L23.0183 0L17.9805 8.81911H21.9844Z",
    fill: "#1F295C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 40.9241V42.6442H1.96859L3.039 40.9241H0Z",
    fill: "url(#paint0_linear_3948_61243)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66801 42.6442H7.51015V40.9241H4.54989C4.13157 40.9241 3.75508 41.0422 3.4155 41.276C2.91105 41.6229 2.66005 42.088 2.66005 42.6712V50.8335H4.66801V42.6442Z",
    fill: "url(#paint1_linear_3948_61243)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4632 46.7905V45.0704V45.068H10.7559V42.6417H15.8668L16.8068 40.9216H10.6402C10.2219 40.9216 9.84539 41.0398 9.50581 41.2735C9.00136 41.6205 8.75036 42.0856 8.75036 42.6688V49.0839C8.75036 49.4579 8.87094 49.8024 9.11455 50.1149C9.49597 50.5923 10.0053 50.831 10.6402 50.831H16.8068L15.8668 49.111H10.7559V46.7905H15.4632Z",
    fill: "url(#paint2_linear_3948_61243)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5901 49.517L25.0601 50.8335V50.8359H27.1985L24.2776 42.5433C23.8617 41.3867 23.1998 40.806 22.2967 40.7961C21.3911 40.806 20.7267 41.3867 20.301 42.5433L17.3925 50.8359H19.5308L22.2942 42.9345L23.9897 47.7969H21.3173L20.2469 49.517H24.5901Z",
    fill: "url(#paint3_linear_3948_61243)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.709 49.1134C31.3104 49.1134 30.9412 48.9732 30.6017 48.6951C30.1144 48.2866 29.8708 47.7452 29.8708 47.0661V44.6939C29.8708 44.2338 30.0013 43.8155 30.2621 43.4414C30.6263 42.9124 31.1086 42.6466 31.709 42.6466H33.0378C33.1067 42.6466 33.1854 42.6515 33.2716 42.6589C33.8105 42.7278 34.2312 42.9591 34.5364 43.3504L36.2712 42.0068C36.0793 41.8247 35.8184 41.65 35.4887 41.4851C34.6988 41.1111 33.8818 40.9241 33.0378 40.9241H31.709C30.673 40.9241 29.7773 41.2784 29.0219 41.9921C28.2566 42.7303 27.8752 43.6309 27.8752 44.6915V47.0636C27.8752 48.0799 28.2369 48.9535 28.9579 49.6843C29.7133 50.4496 30.6312 50.831 31.709 50.831H33.0378C33.3331 50.831 33.6579 50.7966 34.0147 50.7277C35.0334 50.5382 35.784 50.2109 36.2712 49.7507L34.5364 48.422C34.5019 48.4638 34.4576 48.513 34.406 48.5647C34.0319 48.9313 33.5767 49.1134 33.0378 49.1134H31.709Z",
    fill: "url(#paint4_linear_3948_61243)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0988 50.8335H46.1067H46.1092V40.9241H44.1012V45.0704H40.4889L39.8097 46.1532V40.9241H37.8141V50.8335H39.8097V46.7905H44.0988V50.8335Z",
    fill: "url(#paint5_linear_3948_61243)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.271 30.381C36.8741 30.6542 36.6757 31.0186 36.6757 31.4783V36.5217C36.6757 36.8157 36.7708 37.089 36.9609 37.3333C37.2627 37.7101 37.6636 37.8965 38.1597 37.8965H43L42.2642 36.5424H38.2547V34.7164H41.9501V33.3623H38.2547V31.4576H42.2642L43 30.1035H38.1597C37.8331 30.1035 37.5355 30.1946 37.271 30.381Z",
    fill: "url(#paint6_linear_3948_61243)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.148 30.1035H25.5814V37.8965H27.148V30.1035Z",
    fill: "url(#paint7_linear_3948_61243)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1299 30.1035C21.8034 30.1035 21.5057 30.1946 21.2412 30.381C20.8444 30.6542 20.646 31.0186 20.646 31.4783V37.8965H22.2208V31.4576H24.4529V30.1035H22.1299Z",
    fill: "url(#paint8_linear_3948_61243)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9477 30.1035H18.5627V31.4576H20.1086L20.9477 30.1035Z",
    fill: "url(#paint9_linear_3948_61243)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84417 30C6.1332 30.0083 5.61238 30.4638 5.27757 31.3747H5.2817L3 37.8965H4.67821L6.8483 31.6853L8.17929 35.5072H6.07947L5.24037 36.8613H8.64638L9.01426 37.8965H10.6925L8.39837 31.3747C8.07182 30.4638 7.55513 30.0083 6.84417 30Z",
    fill: "url(#paint10_linear_3948_61243)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2308 37.8965H15.2765L15.2807 37.9006C15.5121 37.9006 15.7684 37.8716 16.0495 37.8178C16.8473 37.6646 17.4384 37.4079 17.8186 37.0476L16.4587 36C16.4298 36.0331 16.3967 36.0704 16.3554 36.1118C16.0619 36.3975 15.7023 36.5424 15.2807 36.5424H14.2349C13.9249 36.5424 13.6314 36.4348 13.3668 36.2153C12.9824 35.8965 12.7923 35.47 12.7923 34.9358V33.0683C12.7923 32.7039 12.8915 32.3768 13.0982 32.0828C13.3875 31.6646 13.7637 31.4576 14.2349 31.4576H15.2807H15.2807C15.3386 31.4576 15.3964 31.4576 15.4667 31.4658C15.8883 31.5197 16.219 31.7019 16.4587 32.0083L17.8186 30.9524C17.6657 30.8075 17.4632 30.6708 17.2027 30.5424C16.5827 30.2526 15.942 30.1035 15.2807 30.1035H14.2349C13.4247 30.1035 12.722 30.3851 12.1268 30.9441C11.5274 31.5238 11.2257 32.2319 11.2257 33.0642V34.9317C11.2257 35.7308 11.5068 36.4182 12.0731 36.9938C12.6642 37.5942 13.3834 37.8965 14.2308 37.8965Z",
    fill: "url(#paint11_linear_3948_61243)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1607 30.1035L30.4548 36.6253C30.7813 37.5362 31.298 37.9917 32.009 38C32.72 37.9917 33.2408 37.5362 33.5756 36.6253L35.8573 30.1035H34.1791L32.009 36.3147L29.8389 30.1035H28.1607Z",
    fill: "url(#paint12_linear_3948_61243)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3948_61243",
    x1: 0,
    y1: 45.816,
    x2: 46.1092,
    y2: 45.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3948_61243",
    x1: 0,
    y1: 45.816,
    x2: 46.1092,
    y2: 45.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3948_61243",
    x1: 0,
    y1: 45.816,
    x2: 46.1092,
    y2: 45.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3948_61243",
    x1: 0,
    y1: 45.816,
    x2: 46.1092,
    y2: 45.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3948_61243",
    x1: 0,
    y1: 45.816,
    x2: 46.1092,
    y2: 45.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3948_61243",
    x1: 0,
    y1: 45.816,
    x2: 46.1092,
    y2: 45.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3948_61243",
    x1: 3,
    y1: 34,
    x2: 43,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3948_61243",
    x1: 3,
    y1: 34,
    x2: 43,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3948_61243",
    x1: 3,
    y1: 34,
    x2: 43,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3948_61243",
    x1: 3,
    y1: 34,
    x2: 43,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3948_61243",
    x1: 3,
    y1: 34,
    x2: 43,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3948_61243",
    x1: 3,
    y1: 34,
    x2: 43,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3948_61243",
    x1: 3,
    y1: 34,
    x2: 43,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadLogo);
export default __webpack_public_path__ + "static/media/lead_logo.525a8502762fc3c75655a51643723d75.svg";
export { ForwardRef as ReactComponent };